/**
 * @Date: 2020-06-17 16:02
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import http from '../http'

// 渠道分页查询
export const channelQueryPage = data => {
  return http.request({
    url: '/channel/channelQueryPage',
    data,
    method: 'post'
  })
}

// 渠道账号新增
export const channelAcctAdd = data => {
  return http.request({
    url: '/channel/channelAcctAdd',
    data,
    method: 'post'
  })
}

// 渠道账户分页查询
export const channelAcctQueryPage = data => {
  return http.request({
    url: '/channel/channelAcctQueryPage',
    data,
    method: 'post'
  })
}

// 渠道账号更新
export const channelAcctUpdate = data => {
  return http.request({
    url: '/channel/channelAcctUpdate',
    data,
    method: 'post'
  })
}

// 渠道能力查询
export const channelCapabilityQuery = data => {
  return http.request({
    url: '/channel/channelCapabilityQuery',
    data,
    method: 'post'
  })
}

// 渠道新增
export const channelAdd = data => {
  return http.request({
    url: '/channel/channelAdd',
    data,
    method: 'post'
  })
}

// 渠道约束查询
export const channelConstraintQueryByChannel = data => {
  return http.request({
    url: '/channel/channelConstraintQueryByChannel',
    data,
    method: 'post'
  })
}

// 渠道列表查询
export const channelQueryList = data => {
  return http.request({
    url: '/channel/channelQueryList',
    data,
    method: 'post'
  })
}

// 渠道子账号新增
export const channelSubAcctAdd = data => {
  return http.request({
    url: '/channel/channelSubAcctAdd',
    data,
    method: 'post'
  })
}

// 渠道子账户分页查询
export const channelSubAcctQueryPage = data => {
  return http.request({
    url: '/channel/channelSubAcctQueryPage',
    data,
    method: 'post'
  })
}

// 渠道更新
export const channelUpdate = data => {
  return http.request({
    url: '/channel/channelUpdate',
    data,
    method: 'post'
  })
}

// 渠道所有能力查询
export const channelTotalCapabilityQuery = data => {
  return http.request({
    url: '/channel/channelTotalCapabilityQuery',
    data,
    method: 'post'
  })
}

// 保存渠道能力树节点
export const channelCapabilityUpdate = data => {
  return http.request({
    url: '/channel/channelCapabilityUpdate',
    data,
    method: 'post'
  })
}
